<template lang="pug">
  div
    page_header(title="Startups", subhead="Add New")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "startups.index"}')
        i.feather-arrow-left
        | Back
    
    .row
      .col-sm-12
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-6
                form_input(type="text" name="name" label="Name" placeholder="Enter Startup Name" v-model="form.name")             
                form_input(type="text" name="address" label="Address" placeholder="Enter Address" v-model="form.address")
                form_input(type="text" name="incubator" label="Incubator" placeholder="Enter Incubator" v-model="form.incubator")
                form_input(type="date" name="incorporation" label="Date of Incoporation" placeholder="Enter Incoporation" v-model="form.incorporation")
                form_input(type="text" name="dipp" label="DIPP No" placeholder="Enter Dipp No" v-model="form.dipp")
                form_input(type="text" name="uid" label="KSUM Unique ID" placeholder="Enter KSUM UID" v-model="form.uid")
                form_input(type="url" name="brochure" label="Brochure Link" placeholder="Brochure Link" v-model="form.brochure")
                form_input(type="url" name="pitch_video" label="Pitch Video Link" placeholder="Pitch Video Link" v-model="form.pitch_video")
                
              .col-sm-6      
                form_input(type="text" name="district" label="District" placeholder="Enter District" v-model="form.district")
                
                form_input(type="url" name="website" label="Website" placeholder="Enter Website" v-model="form.website")
                form_input(type="url" name="linkedin" label="LinkedIn" placeholder="LinkedIn URL" v-model="form.linkedin") 
                
                //logo
                imageSelect(v-model="form.logo" :h="281" :w="500" modal_class="modal-lg")

            .row
              .col-sm-12
                .mb-3
                  label.form-label Brief
                  textarea.form-control(v-model="form.brief" rows="5" maxLength="500")


            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import imageSelect from '@/components/imageSelect'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Startups',
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    imageSelect
  },
  data(){
    return {
      roles: [],
      form: {
        name: '',
        address: '',
        district: '',
        website: '',
        linkedin: '',
        incorporation: '',
        incubator: '',
        dipp: '',
        uid: '',
        logo: 'data:image/png;base64,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',
        brochure: '',
        pitch_video: ''

      },
      blank: {
        name: '',
        address: '',
        district: '',
        website: '',
        linkedin: '',
        incorporation: '',
        incubator: '',
        dipp: '',
        uid: '',
        logo: 'data:image/png;base64,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',
        brochure: '',
        pitch_video: ''
      }
    }
  },
  computed: {
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    resetForm(){
      this.form = JSON.parse(JSON.stringify(this.blank));
    },
    submit(){
      var vm = this;
      this.call({_vm:this, endpoint: 'admin/startups', method: 'POST', data: this.form}).then(()=>{
        vm.resetForm();
      })
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: 'admin/startups/create', method: 'GET'}).then((data)=>{
      vm.roles = data;
    })
  }
}
</script>
